import { ArrowRight, Phone } from "lucide-react";

export function FaqContactCard({
  title,
  body,
  cta,
}: {
  title: string;
  body: string;
  cta: string;
}) {
  return (
    <div className="faq-contact-card flex w-full flex-col gap-[18px] rounded-home-24 bg-home-navy p-7 text-home-cream shadow-[10px_10px_0_rgba(15,27,45,0.14)]">
      <p className="text-[22px] font-bold leading-tight">{title}</p>
      <p className="text-[16px] leading-snug text-home-muted">{body}</p>
      <a
        href="tel:+994002222222"
        className="inline-flex min-h-11 items-center gap-2 text-[18px] font-semibold text-home-cream"
      >
        <Phone className="h-[18px] w-[18px] shrink-0 text-home-accent" aria-hidden="true" />
        +994 00 222 22 22
      </a>
      <a
        href="#contact"
        className="faq-contact-btn inline-flex min-h-11 w-fit items-center justify-center gap-2 rounded-home-pill bg-home-accent px-[26px] py-[14px] text-[17px] font-bold text-home-navy shadow-[0_6px_0_var(--home-cream)]"
      >
        {cta}
        <ArrowRight className="h-5 w-5" aria-hidden="true" />
      </a>
    </div>
  );
}
